import Modal from "src/Components/Modal/Modal";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import {
  BaseExecutionDetailSearch, BaseExecutionTriggerRow,
  getBaseExecutionTriggerTable,
} from "src/Requests/baseMarketMaking";

interface Props { taskId: number | null; onClose: () => void }

const ExecutionTriggers = ({ taskId, onClose }: Props) => taskId == null ? null : <Modal
  onClose={onClose} modalBoxClassName="!w-[1400px]"
  UI={<div className="min-h-[240px] overflow-auto" dir="rtl">
    <TableTemplate<BaseExecutionDetailSearch, BaseExecutionTriggerRow>
      getDataTable={getBaseExecutionTriggerTable}
      searchParameters={{ taskId }} refreshTableTime={5000} withSort
      TableUI={({ reports, onAction, sortingType, setSortingType }) =>
        <CommonTableUI reports={reports} onAction={onAction}
          sortingType={sortingType} setSortingType={setSortingType}
          renderCell={(row, header) => header.headerName === "Factor"
            ? <div dir="ltr" className="w-full">{row.factor == null ? "-" : row.factor.toFixed(3)}</div>
            : undefined} />}
    />
  </div>} />;

export default ExecutionTriggers;
